import React from 'react';

// Tiny inline line+area chart, no axes, drawn as a single SVG so the
// visual language matches TimeChart (same line+faded-area combination,
// no second chart library involved).
//
// Props:
//   data    — [{label, value}, ...]
//   height  — px (default 40)
//   color   — hex (default var(--ross-indigo), Ross brand indigo)
export default function Sparkline({ data, height = 40, color = 'var(--ross-indigo)' }) {
  if (!data || data.length < 2) {
    return <div style={{ height, opacity: 0.3 }} />;
  }
  const w = 200;
  const h = height;
  const pad = 2;
  const vals = data.map(d => Number(d.value) || 0);
  const max = Math.max(...vals);
  const min = Math.min(...vals);
  const range = max - min || 1;
  const stepX = (w - pad * 2) / (data.length - 1);
  const yOf = (v) => h - pad - ((v - min) / range) * (h - pad * 2);

  const linePath = data.map((d, i) => {
    const x = pad + i * stepX;
    const y = yOf(Number(d.value) || 0);
    return `${i === 0 ? 'M' : 'L'}${x.toFixed(2)},${y.toFixed(2)}`;
  }).join(' ');

  const areaPath = `M${pad},${h} `
    + data.map((d, i) => {
        const x = pad + i * stepX;
        const y = yOf(Number(d.value) || 0);
        return `L${x.toFixed(2)},${y.toFixed(2)}`;
      }).join(' ')
    + ` L${(w - pad).toFixed(2)},${h} Z`;

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      style={{ width: '100%', height, display: 'block' }}
    >
      <path d={areaPath} fill={color} opacity={0.12} />
      <path d={linePath} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" />
    </svg>
  );
}
